<template>
    <mutasi-cash :metode="'transfer'"></mutasi-cash>
</template>

<script>
import MutasiCash from '../mutasi-cashs/Index';

export default {
    name: "mutasi-transfer",

    components: {
        MutasiCash,
    },

    data() {
        return {
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
    },

    methods: {
    },
}
</script>
